// ABOUTME: The placeholder drawn while the feed loads: the filter row and two card-shaped blocks where the cards will be.
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

export const JobFeedSkeleton = () => (
  <Box data-testid="job-feed-skeleton">
    <Skeleton
      variant="rounded"
      height={40}
      width={200}
      sx={{ borderRadius: 5, mb: 2 }}
    />
    <Skeleton variant="rounded" height={280} sx={{ borderRadius: 4, mb: 2 }} />
    <Skeleton variant="rounded" height={280} sx={{ borderRadius: 4 }} />
  </Box>
);
